<template>
  <v-app style="background: #F5F5F5;">
    <!--<v-navigation-drawer-->
    <!--v-model="drawer"-->
    <!--dark-->
    <!--app-->
    <!--hide-overlay-->
    <!--floating-->
    <!--class="transparent elevation-0"-->
    <!--style="opacity:0.8"-->
    <!--&gt;-->
    <v-navigation-drawer
      v-model="drawer"
      clipped app dark hide-overlay temporary
      :class="navC"
      :width="this.$vuetify.breakpoint.xsOnly ? 200 : 300"
      style="opacity:0.8"
    >
      <v-list>
        <v-list-tile>
          <v-list-tile-action>
            <v-btn class="transparent red--text text--darken-2" icon fab flat @click="drawer=false">
              <v-icon @click="drawer = false" class="red--text text--darken-2">close</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
        <v-list-tile v-for="m in menus" :key="m.text" @click="()=>jump(m.id)">
          <!--<v-list-tile-title class="grey&#45;&#45;text text&#45;&#45;darken-2">-->
          <v-list-tile-action>
            <v-icon class="grey--text text--darken-2">{{m.icon}}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              <a
                class="header grey--text text--darken-2 text-xs-center">
                {{m.text}}
              </a>
            </v-list-tile-title>
          </v-list-tile-content>
          <!--</v-list-tile-title>-->
        </v-list-tile>
        <v-divider/>
      </v-list>
    </v-navigation-drawer>
    <!--<v-toolbar app fixed clipped-left absolute flat class="transparent">-->
      <!--<v-toolbar-side-icon class='grey&#45;&#45;text text&#45;&#45;darken-2' @click="drawer = !drawer"></v-toolbar-side-icon>-->
    <!--</v-toolbar>-->
    <v-btn v-if="!drawer" @click="drawer = !drawer" fixed dark fab flat top left class="transparent text--darken-2 grey--text">
      <v-icon>menu</v-icon>
    </v-btn>
    <v-content>
      <!--<router-view/>-->
      <v-container class="full-container">
        <span v-for="(s,i) in sections" :key="`section-`+i">
          <!--<v-container class="full-container">-->
          <!--<component :is="s.comp" :class="s.cla === 'd' ? 'hidden-sm-and-down' : 'hidden-md-and-up'"/>-->
          <component :is="s.comp" :id="s.id"/>
          <!--</v-container>-->
        </span>
      </v-container>

    </v-content>
  </v-app>
</template>

<script>
  import DLandingPage from './components/desktop/home/Landing'
  import DAbout from './components/desktop/about/About'
  import DExp from './components/desktop/exp/Experience'
  import MLLand from './components/mobile/home/ProfilePicture'
  import MRLand from './components/mobile/home/Details'
  import MAbout from './components/mobile/about/About'
  import {scroller} from 'vue-scrollto/src/scrollTo'

  export default {
    components: {
      DLandingPage, DAbout, MLLand, MRLand, MAbout, DExp
    },
    mounted() {
    },
    methods: {
      jump(id) {
        // console.log(id);
        this.drawer = false;
        this.scroll(id);
      }
    },
    computed: {
      menus() {
        let desktop = [
          {
            text: "Bio",
            id: "#dbio",
            icon: "home"
          },
          {
            text: "About",
            id: "#dabout",
            icon: 'info'
          },
          {
            text: "Projects",
            id: "#dexp",
            icon: "favorite"
          }
        ];

        let mobile = [
          {
            text: "Profile",
            id: '#mprofile',
            icon: 'home'
          },
          {
            text: "Bio",
            id: '#mbio',
            icon: 'account_circle'
          },
          {
            text: 'About',
            id: '#mabout',
            icon: 'info'
          },
          {
            text: "Projects",
            id: "#mexp",
            icon: "favorite"
          }
        ];

        return this.$vuetify.breakpoint.xsOnly ? mobile : desktop;
      },
      sections() {
        let desktop = [
          {
            comp: DLandingPage,
            id: "dbio"
          },
          {
            comp: DAbout,
            id: "dabout"
          },
          {
            comp: DExp,
            id: "dexp"
          }
        ];

        let mobile = [
          {
            comp: MLLand,
            id: 'mprofile'
          },
          {
            comp: MRLand,
            id: 'mbio'
          },
          {
            comp: MAbout,
            id: 'mabout'
          },
          {
            comp: DExp,
            id: "mexp"
          }
        ];
        return this.$vuetify.breakpoint.xsOnly ?
          mobile : desktop;
      }
    },
    data() {
      return {
        scroll: scroller(),
        drawer: false,
        navC: {
          transparent: true,
          'grey lighten-4': true,
          'elevation-0': true,
          'mt-5': this.$vuetify.breakpoint.xsOnly
        }
      }
    },
    name: 'App'
  }
</script>



// WEBPACK FOOTER //
// src/App.vue